(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/sport/result-boxes/assets/javascripts/helpers/player-forecast.js') >= 0) return;  svs.modules.push('/components/sport/result-boxes/assets/javascripts/helpers/player-forecast.js'); 'use strict';

svs.sport.result_boxes.playerForecast = function (_playerResults) {
  if (!_playerResults) return;

  var setPlayerResults = function setPlayerResults(playerResults) {
    _playerResults = playerResults;
  };

  var getNumCorrect = function getNumCorrect() {
    return _getLastPlayerResult().numCorrect;
  };

  var getNumDrawResults = function getNumDrawResults() {
    return _getLastPlayerResult().drawResults.length;
  };

  var getWinAmount = function getWinAmount() {
    return _getLastPlayerResult().winAmount;
  };

  var getWinResult = function getWinResult() {
    return _getLastPlayerResult().winresult;
  };

  var getDatePoints = function getDatePoints(startTime) {
    var formattedStartTime = moment(startTime).format('D/M HH:mm'),
        endTime = _getEndTime();

    return [{
      dateTime: formattedStartTime,
      xPoint: 0
    }, {
      dateTime: endTime,
      xPoint: 1
    }];
  };

  var _getEndTime = function _getEndTime() {
    var lastPlayerResult = _getLastPlayerResult();

    return moment(lastPlayerResult.highestRegtime ? lastPlayerResult.highestRegtime : lastPlayerResult.get('highestRegtime')).format('D/M HH:mm');
  };

  var getPoints = function getPoints() {
    var pointsArray = [];
    var numberOfResultChanges = _playerResults.length;

    _playerResults.forEach(function (result, index) {
      if (index === 0) {
        pointsArray.push({
          x: 0,
          numCorrect: result.numCorrect !== undefined ? result.numCorrect : result.get('numCorrect')
        });
      } else {
        pointsArray.push({
          x: (index + 1) / numberOfResultChanges,
          numCorrect: result.numCorrect !== undefined ? result.numCorrect : result.get('numCorrect')
        });
      }
    });

    return pointsArray;
  };

  var _getLastPlayerResult = function _getLastPlayerResult() {
    var lastPlayerResults = _playerResults[_playerResults.length - 1];

    if (!lastPlayerResults) {
      lastPlayerResults = _playerResults.at(_playerResults.length - 1);
    }

    return lastPlayerResults;
  };

  return {
    getDatePoints: getDatePoints,
    getPoints: getPoints,
    getNumCorrect: getNumCorrect,
    getWinAmount: getWinAmount,
    getWinResult: getWinResult,
    getNumDrawResults: getNumDrawResults,
    setPlayerResults: setPlayerResults
  };
};
 })(window);